import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import ButtonMain from 'modules/assessment-execution/components/ButtonMain';
import { useParams } from 'react-router-dom';
import { useAssessment } from 'modules/assessment-execution/context/assessment.consumer';
import { AssessmentApi } from 'lib/api/assessment';
import { FirstPage } from 'modules/assessment-execution/components/FirstPage';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

type AssessmentState =
  | 'not-started'
  | 'finished'
  | 'interrupted'
  | 'cancelled'
  | undefined;

export const InitialPage = () => {
  const { analystRequestId } = useParams();
  const { setAnalystRequest, handleNextPage, analystRequest } = useAssessment();
  const { enqueueSnackbar } = useSnackbar();
  const [assessmentState, setAssessmentState] =
    React.useState<AssessmentState>();

  useEffect(() => {
    if (!analystRequestId) return;

    const load = async () => {
      try {
        const request = await AssessmentApi.getAnalystRequest(analystRequestId);
        setAnalystRequest(request);

        if (request.status === 'CANCELADO') {
          setAssessmentState('cancelled');
          return;
        }

        const assessmentResponse =
          await AssessmentApi.getAssessmentResponseByAnalysrRequest(
            analystRequestId,
          );

        if (!assessmentResponse) {
          setAssessmentState('not-started');
        } else if (assessmentResponse.finishedAt) {
          setAssessmentState('finished');
        } else {
          setAssessmentState('interrupted');
        }
      } catch (error) {
        enqueueSnackbar('Erro ao carregar a solicitação.', {
          variant: 'error',
        });
        console.error(error);
      }
    };

    load();
  }, [analystRequestId]);

  const whatsappButton = (
    <Button
      startIcon={<WhatsAppIcon />}
      onClick={() => {
        const whatsappUrl = `https://wa.me/5511910394147?text=${encodeURIComponent(
          `Olá, preciso de ajuda para fazer a prova MS.`,
        )}`;
        window.open(whatsappUrl, '_blank');
      }}
      sx={{
        fontWeight: 'bold',
        color: 'rgba(37, 211, 102, 1)',
        alignSelf: 'flex-start',
        textTransform: 'none',
        fontSize: {
          xs: '16px',
          md: '20px',
        },
        '& .MuiButton-startIcon': {
          '& > *': {
            width: '24px',
            height: '24px',
          },
        },
      }}
    >
      Central WhatsApp
    </Button>
  );

  return (
    <FirstPage>
      {assessmentState === 'cancelled' ? (
        <>
          <Typography
            variant="body1"
            style={{ whiteSpace: 'pre-line', color: '#F4F1F1' }}
          >
            Seja bem-vindo(a) à plataforma de trilhas de competências da MS.
            <br />
            <br />
            Esse link foi cancelado. Por favor, entre em contato com o nosso
            suporte.
            <br />
            <br />
            <p>
              Acesse nossa <strong>Central WhatsApp</strong>, clicando abaixo.
            </p>
          </Typography>
          {whatsappButton}
        </>
      ) : assessmentState === 'finished' ? (
        <>
          <Typography
            variant="body1"
            style={{ whiteSpace: 'pre-line', color: '#F4F1F1' }}
          >
            Olá! Seja bem-vindo(a) à plataforma de trilhas de competências da
            MS.
            <br />
            <br />
            Nosso sistema detectou que você já realizou essa prova, por isso não
            é possível acessar a plataforma novamente.
            <br />
            <br />
            <p>
              Se precisar de ajuda, acesse nossa
              <strong> Central WhatsApp</strong>, clicando abaixo.
            </p>
          </Typography>
          {whatsappButton}
        </>
      ) : assessmentState === 'interrupted' ? (
        <>
          <Typography
            variant="body1"
            style={{ whiteSpace: 'pre-line', color: '#F4F1F1' }}
          >
            Olá! Seja bem-vindo(a) à plataforma de trilhas de competências da
            MS.
            <br />
            <br />
            Houve um problema ao finalizar sua prova. Por favor, entre em
            contato com o nosso suporte.
            <br />
            <br />
            <p>
              Acesse nossa <strong> Central WhatsApp</strong>, clicando abaixo.
            </p>
          </Typography>
          {whatsappButton}
        </>
      ) : assessmentState === 'not-started' ? (
        <>
          <Typography
            variant="body1"
            style={{ whiteSpace: 'pre-line', color: '#F4F1F1' }}
          >
            Olá! Seja bem-vindo(a) à plataforma de trilhas de competências da
            MS.
            <br />
            <br />
            Você realizará algumas provas que trarão dados sobre sua atenção,
            perfil comportamental, memória, entre outros, dependendo da
            solicitação de nosso cliente.
            <br />
            <br />
            Esta trilha foi solicitada pela{' '}
            <b>{analystRequest?.company?.name}</b>.
            <br />
            <br />
            <b>
              Nossas provas são otimizadas para serem realizadas através de um
              computador ou laptop
            </b>
            , mas caso você não possua ou não tenha onde realizar, não se
            preocupe, pois elas também foram adaptadas para serem feitas no
            celular.
          </Typography>
          <ButtonMain
            onClick={handleNextPage}
            text={!analystRequest ? 'Carregando...' : 'Continuar'}
            disabled={!analystRequest}
          ></ButtonMain>
        </>
      ) : (
        <></>
      )}
    </FirstPage>
  );
};

export default InitialPage;
